import React, { Component } from 'react';
import { Modal } from 'react-bootstrap'
import {calculateTotalProfit, calculateBetReturn} from 'utils/calculations'
import {currencyToText, convertCurrency} from 'utils/converters'
import moment from 'moment'
import ClipboardButton from 'react-clipboard.js'
import Select from 'react-select'



export default class StatusModal extends Component {

  constructor(props) {
    super(props)
    this.generateReport = this.generateReport.bind(this)
    this.getROI = this.getROI.bind(this)
    this.handleCopy = this.handleCopy.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.state = {
      timeFrame: 1
    }
  }

  generateReport() {
    if (this.props.bets.length === 0)
      return 'You don\'t have any bets yet, place a few bets and come back!'
    let timeFrame
    let totalProfit
    let bets = []
    if(this.state.timeFrame === 1) {
      timeFrame = moment(this.props.bets[0].createdAt).fromNow(true)
      bets = this.props.bets
    }
    if(this.state.timeFrame === 2) {
      let yesterday = moment().subtract(1, 'day')
      timeFrame = 'last 24 hours'
      this.props.bets.filter(bet => {
        if (moment(bet.createdAt) > yesterday)
          bets.push(bet)
      })
    }
    if(this.state.timeFrame===3) {
      let aboutAWeekAgo = moment().subtract(1, 'week')
      timeFrame = 'the last week'
      this.props.bets.filter(bet => {
        if(moment(bet.createdAt) > aboutAWeekAgo) {
          bets.push(bet)
        }
      })
    }
    totalProfit = currencyToText(calculateTotalProfit(bets, this.props.currencies, this.props.mainCurrency), this.props.mainCurrency)

    return `I've made ${totalProfit} in ${timeFrame} starting with ${currencyToText(this.props.startingBankroll, this.props.mainCurrency)} using edgebet. My avg ROI per bet is ${this.getROI(bets)}% `

  }
  getROI(betArray) {
    let returned = 0
    let wagered = 0
    betArray.filter(bet => bet.status !== 1).forEach(bet => {
      wagered += convertCurrency(bet.currency, this.props.mainCurrency, bet.wager, this.props.currencies);
      returned += convertCurrency(bet.currency, this.props.mainCurrency,
                                  calculateBetReturn(bet.wager, bet.odds, bet.status),
                                  this.props.currencies)
    })
    return Math.round((returned - wagered) / wagered * 100 * 10) / 10
  }

  handleCopy() {
    return alert('Successfully copied')
  }

  handleSelectChange(e) {
    //e.value should never be null but if it is catch err, and set to default val
    let val
    try {
      val = e.value
    }
    catch(e) {
      val = 1
    }
    this.setState({
      timeFrame:val
    })
  }


  render() {
    let timeFrameOptions = [
      {
        value:1, label:'Results for All Time'
      },
      {
        value:2, label:'Results for last 24 hours'
      },
      {
        value:3, label:'Results for past week'
      }
    ]
    return (
          <Modal show={this.props.showModal} onHide={this.props.closeModal}>
            <Modal.Header closeButton>
              <Modal.Title> Here You go! </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <label htmlFor='select' className='col-xs-3 control-label'> Select a time frame </label>
              <div className='col-xs-9'>
                <Select options={timeFrameOptions} name='Time Range' value={this.state.timeFrame} onChange={this.handleSelectChange}> </Select>
              </div>
              <div className='row'>
                <label htmlFor='result' className='col-xs-3 control-label'>
                  Result
                </label>
                <div className='col-xs-9'>
                  <textarea className='form-control col-xs-9' value={this.generateReport()} disabled />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className='col-xs-9 col-xs-offset-3'>
                <ClipboardButton className=' clipboard btn btn-primary' button-title='copy to clipboard' data-for='modal' onSuccess={this.handleCopy} data-clipboard-text={this.generateReport()}> Copy Result To ClipBoard
                </ClipboardButton>
              </div>
            </Modal.Footer>
          </Modal>

      )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/analytics/statusModal.js
 **/